import React from 'react';

import { Inline } from '@styleseat/ui';
import { colors } from '@styleseat/brand';

import { BodyText, Touchable } from '../../../ui';
import { BasicCirclePlusIcon } from '../../../ui/Icons';
import { TextSearchBar } from '../../../shared/TextSearchBar';
import IncentiveToAddContainer from '../IncentiveToAdd/IncentiveToAddContainer';
import { PublicProvider } from '../../../../api/Providers';

export type ContactListHeaderProps = {
  searchText?: string;
  showAddButton: boolean;
  provider: Pick<PublicProvider, 'id' | 'creation_time' | 'profile_phase_one_complete_date'>;
  topBarSearchBox: boolean;
  onSearchBoxFocus?: () => void; // invoked when anything is typed into the search box
  onAddClientClick: () => void;
  onSearchChange: (value: string) => void;
  invitedCount?: number;
  showEmptyState: boolean;
  showAddIncentive: boolean;
  renderTopBarItems?: () => React.ReactNode;
};

const SEARCH_BOX_PLACEHOLDER = 'Search name or phone number';

export const ContactListHeader = ({
  searchText,
  showAddButton,
  provider,
  onAddClientClick,
  onSearchChange,
  onSearchBoxFocus,
  invitedCount = 0,
  showEmptyState,
  topBarSearchBox,
  showAddIncentive,
  renderTopBarItems,
}: ContactListHeaderProps) => (
  <React.Fragment>
    {topBarSearchBox && (
      <TextSearchBar
        onChangeSearch={onSearchChange}
        searchTerm={searchText}
        testID="contact-list-search"
        placeholder={SEARCH_BOX_PLACEHOLDER}
        onFocus={onSearchBoxFocus}
      >
        {renderTopBarItems?.()}
      </TextSearchBar>
    )}

    {(showAddButton && !showEmptyState) && (
      <Touchable onClick={onAddClientClick} testID="contact-list-add">
        <Inline
          alignItems="center"
          space={16}
          padding={16}
          borderStyle="solid"
          borderYWidth={1}
          borderColor={colors.grey3}
          color={colors.whiteWash}
        >
          <BasicCirclePlusIcon width={34} height={34} />
          <BodyText textAlign="left">
            Add New Client
          </BodyText>
        </Inline>
      </Touchable>
    )}

    {showAddIncentive && (
      <IncentiveToAddContainer
        provider={provider}
        updatedInviteCount={invitedCount}
      />
    )}
  </React.Fragment>
);
